import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import CollapsibleTextBlock from '../../generic/CollapsibleTextBlock';

type Props = {
  description?: string;
  hasDarkBackground?: boolean;
};

/**
 * PackageDetailsMetadataDescription displays the description for a package,
 * within a CollapsableTextBlock so that it doesn't get too wild.
 */
const PackageDetailsMetadataDescription: VoidFunctionComponent<Props> = ({ description, hasDarkBackground }) => (
  <div className={cx('package-inventory__details__metadata__description', {
    'package-inventory__details__metadata__description--dark': hasDarkBackground,
  })}>
    {description
      ? <CollapsibleTextBlock text={description} />
      : <span className="italic">No description found</span>}
  </div>
);

export default PackageDetailsMetadataDescription;
